import { createApi } from '@reduxjs/toolkit/query/react';

import { ApiTag } from '../api-tags.enum';
import { HttpMethod } from '../http-method.enum';
import { PatientDto } from '@/lib/types';
import { apiBaseQuery } from '../base-query';

export const patientsApi = createApi({
  reducerPath: 'patientsApi',
  tagTypes: [ApiTag.Patient],
  refetchOnReconnect: true,
  refetchOnFocus: true,
  baseQuery: apiBaseQuery,
  endpoints: (builder) => ({
    getAllPatients: builder.query<
      PatientDto[],
      { includeDeleted?: boolean } | void
    >({
      query: (params) => ({
        url: `/patients/list`,
        method: HttpMethod.Get,
        params: params || {},
      }),
      providesTags: (result) =>
        result
          ? [
              ApiTag.Patient,
              ...result.map(({ id }) => ({
                type: ApiTag.Patient as const,
                id,
              })),
            ]
          : [ApiTag.Patient],
    }),
    getPatientById: builder.query<PatientDto, string>({
      query: (id) => `/patients/list/${id}`,
      providesTags: (result, error, id) =>
        result ? [{ type: ApiTag.Patient, id }] : [ApiTag.Patient],
    }),
    deletePatient: builder.mutation<null, string>({
      query: (id) => ({
        url: `/patients/${id}`,
        method: HttpMethod.Delete,
      }),
      invalidatesTags: (result, error, id) => [
        ApiTag.Patient,
        { type: ApiTag.Patient, id },
      ],
    }),
    restorePatient: builder.mutation<number, string>({
      query: (id) => ({
        url: `/patients/${id}/restore`,
        method: HttpMethod.Patch,
      }),
      invalidatesTags: (result, error, id) => [
        ApiTag.Patient,
        { type: ApiTag.Patient, id },
      ],
    }),
  }),
});

export const {
  useGetAllPatientsQuery,
  useGetPatientByIdQuery,
  useDeletePatientMutation,
  useRestorePatientMutation,
} = patientsApi;
